import { httpPost } from "../utils/http.service"

export function firebaseCloudMessagingTokenCreate (body: any) {
  return httpPost(`/firebase_cloud_messaging_token`, { firebase_cloud_messaging_token: body })
}
